import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import Hls from "hls.js";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {PreviewFileHlsDialogData} from "../types/preview-file-hls-modal.types";
import {MatButton} from "@angular/material/button";
import {previewFileHlsModalName} from "../configs/preview-file-hls-config";

@Component({
  selector: 'app-preview-file-hls-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton
  ],
  templateUrl: './preview-file-hls-modal.component.html',
  styleUrl: './preview-file-hls-modal.component.scss'
})
export class PreviewFileHlsModalComponent extends BaseModalComponent {
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

  private previewFileHlsDialogData = inject<PreviewFileHlsDialogData>(MAT_DIALOG_DATA);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(previewFileHlsModalName);
  }

  public override ngAfterViewInit(): void {
    this.loadVideo();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(previewFileHlsModalName);
  }

  public loadVideo() {
    const video = this.videoElement.nativeElement;
    const videoSrc = this.previewFileHlsDialogData.url;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play();
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoSrc;
      video.addEventListener('loadedmetadata', () => {
        video.play();
      });
    }
  }
}
